import { Injectable } from '@angular/core';
import { MensagensService } from 'max-ng-lib';
import { HttpClient } from '@angular/common/http';
import { GenericRoteirizadorService } from './generic-roteirizador.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LogoEmpresaService extends GenericRoteirizadorService {

  constructor(private mensagensService: MensagensService, private httpClient: HttpClient) {
    super();
  }

  getMensagensService(): MensagensService {
    return this.mensagensService;
  }

  getHttpClient(): HttpClient {
    return this.httpClient;
  }

  getUrlRecurso(): string {
    return '/logoEmpresa';
  }

  getLogoEmpresa(): Observable<Blob> {
    return this.getHttpClient().get(`${this.getBaseURL()}${this.getUrlRecurso()}/logo`, { responseType: 'blob' });
  }

  excluirLogo() {
    return this.delete('/excluir');
  }
}
